import React from 'react';

import { ShopItem } from '@entities/shop';

import { Category, type ShopItem as ShopItemType } from '@types';

import { Loader } from '@components/loader';
import { StaggerAnimation } from '@components/stagger-animation';

import * as Styled from './shop-items-list.styled';

type OwnProps = {
	items: ShopItemType[];
	isLoadingMore?: boolean;
	categories: Category[];
};

const ShopItemsList: React.FC<OwnProps> = ({ items, categories, isLoadingMore = false }) => {
	return (
		<Styled.ItemsWrapper>
			{items.map((shopItem, index) => (
				<StaggerAnimation key={shopItem.id} index={index} delay={120}>
					<ShopItem categories={categories} shopItem={shopItem} />
				</StaggerAnimation>
			))}

			{isLoadingMore && (
				<Styled.LoadingIndicator>
					<Loader />
				</Styled.LoadingIndicator>
			)}
		</Styled.ItemsWrapper>
	);
};

export default ShopItemsList;
